export var ECustomerType = /*#__PURE__*/ function(ECustomerType) {
    ECustomerType["CORPORATE"] = "C";
    ECustomerType["INDIVIDUAL"] = "I";
    return ECustomerType;
}({});
export var LoyaltyMemberStatus = /*#__PURE__*/ function(LoyaltyMemberStatus) {
    LoyaltyMemberStatus["ACTIVE_MEMBER"] = "ACTIVE_MEMBER";
    LoyaltyMemberStatus["NON_MEMBER"] = "NON_MEMBER";
    LoyaltyMemberStatus["FROZEN_ACTIVE_MEMBER"] = "FROZEN_ACTIVE_MEMBER";
    LoyaltyMemberStatus["INACTIVE_MEMBER"] = "INACTIVE_MEMBER";
    LoyaltyMemberStatus["FROZEN_INACTIVE_MEMBER"] = "FROZEN_INACTIVE_MEMBER";
    return LoyaltyMemberStatus;
}({});
